const generateFormList = ({ disabled, form, keyPrefix, salaryTempList }: any) => {
  const currentId = form.getFieldValue([keyPrefix, 'salary_structure_template_id'])

  const { item_dtos = [] } =
    salaryTempList?.find((item: any) => item?.id === currentId) || ({} as any)
  const isChangedField = keyPrefix === 'changed_salary_value'
  const required = !disabled && isChangedField
  const fieldDisabled = !isChangedField || disabled
  const commonPrefix = [keyPrefix]
  const namePrefix = [...commonPrefix, 'salary_details']

  // 过滤为基数项的项
  return item_dtos
    ?.filter((item: any) => item?.base_item_flag === 1)
    ?.reduce((res: any, item: any, index: number) => {
      res.push(
        {
          type: 'Input',
          formItemProps: {
            name: [...namePrefix, index, 'name'],
            initialValue: item.name,
            hidden: true
          },
          colspan: 0
        },
        {
          type: 'Input',
          formItemProps: {
            name: [...namePrefix, index, 'code'],
            initialValue: item.code,
            hidden: true
          },
          colspan: 0
        },
        {
          type: 'InputNumber',
          disabled: fieldDisabled,
          keyStr: `details-${namePrefix?.join('-')}-${item.code}-value`,
          formItemProps: {
            label: item.name,
            name: [...namePrefix, index, 'value']
          },
          required,
          single_line: true,
          single_type: 3,
          elementProps: {
            min: 0,
            precision: 1,
            step: 1,
            maxLength: 10,
            placeholder: '请输入'
          }
        }
      )
      return res
    }, [])
}

export const json = (props: any) => {
  const {
    filed = [],
    optionFilter = [],
    filedValue,
    formInst,
    handleChange,
    reshuffleStatus,
    salaryTempList,
    selectedMovementFieldList
  } = props
  const movement_field = formInst?.getFieldValue('movement_field')
  const isPayStructure = movement_field === 'PAY_STRUCTURE'
  const { name: payStructureLabel = '薪酬结构' } =
    salaryTempList?.find((item: any) => item?.movement_field === 'PAY_STRUCTURE') || {}

  let originalFields: any[] = []
  let changedFields: any[] = []

  // 薪酬结构
  if (isPayStructure) {
    // 原始
    originalFields = [
      {
        type: 'Input',
        disabled: true,
        formItemProps: {
          hidden: true,
          name: ['original_salary_value', 'salary_structure_template_id'],
          required: false
        },
        elementProps: {}
      },
      {
        type: 'Input',
        disabled: true,
        formItemProps: {
          label: `原${payStructureLabel}`,
          name: ['original_salary_value', 'salary_structure_template_name'],
          required: false
        }
      },
      ...generateFormList({
        disabled: false,
        form: formInst,
        salaryTempList,
        keyPrefix: 'original_salary_value'
      })
    ]
    // 变更
    changedFields = [
      {
        type: 'Select',
        formItemProps: {
          label: `变更${payStructureLabel}`,
          name: ['changed_salary_value', 'salary_structure_template_id'],
          required: true
        },
        elementProps: {
          popup: 'array',
          dataList: salaryTempList?.map((y: any) => ({
            ...y,
            value: y.id
          }))
        }
      },
      {
        type: 'Input',
        formItemProps: {
          name: ['changed_salary_value', 'salary_structure_template_name'],
          hidden: true
        },
        colspan: 0
      },
      ...generateFormList({
        disabled: false,
        form: formInst,
        salaryTempList,
        keyPrefix: 'changed_salary_value'
      })
    ]
  }

  return [
    {
      title: '异动项',
      titltProps: {},
      top: true,
      key: '7',
      form_list: [
        {
          type: 'Select',
          formItemProps: {
            label: '异动项',
            name: 'movement_field',
            required: true
          },
          elementProps: {
            dataList: filed
              .map((x) => ({
                text: x?.type_name,
                name: x?.type_name,
                value: x?.type,
                id: x?.type,
                disabled: x?.type === 'EMPLOYEE_STATUS'
              }))
              ?.filter((item: any) => {
                const isCurrentEdit = reshuffleStatus === 'Edit' && item?.value === movement_field
                return isCurrentEdit || !selectedMovementFieldList.includes(item?.value)
              })
              ?.filter((item: any) => !optionFilter?.length || optionFilter?.includes(item.value)),
            handleChange
          }
        },
        {
          type: 'Input',
          disabled: true,
          hide: isPayStructure,
          formItemProps: {
            label: '原数据',
            name: 'original_value',
            required: false
          },
          elementProps: {}
        },

        ...originalFields,
        {
          type: 'Organize',
          hide: filedValue !== 'ORG',
          formItemProps: {
            label: '变更为',
            name: 'changed_value',
            required: true
          },
          elementProps: {
            type: 'changed_value',
            changed_value: {
              selectorParams: {
                with_no_auth: true
              },
              organizeSearchRequestParams: {
                auth: 'NoAuth'
              }
            },
            config: {
              init: reshuffleStatus === 'Edit'
            }
          }
        },
        ...changedFields,
        {
          type: 'SearchSelect',
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'POST'],
            required: true
          },
          hide: filedValue !== 'POST',
          elementProps: {
            type: 'changed_value.POST',
            mode: 'single',
            popup: 'array',
            config: {
              title: '岗位',
              type: 'Post',
              init: reshuffleStatus === 'Edit',
              fieldNames: { value: 'id', name: 'post_name', code: 'post_code' }
            }
          }
        },
        {
          type: 'SearchSelect',
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'HRM_POSITION'],
            required: true
          },
          hide: filedValue !== 'HRM_POSITION',
          elementProps: {
            type: 'changed_value.HRM_POSITION',
            mode: 'single',
            popup: 'array',
            config: {
              title: '职务',
              type: 'Position',
              init: reshuffleStatus === 'Edit',
              fieldNames: { value: 'id', name: 'name', code: 'code' }
            }
          }
        },
        {
          type: 'SearchSelect',
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'POSITION_RANK'],
            required: true
          },
          hide: filedValue !== 'POSITION_RANK',
          elementProps: {
            type: 'changed_value.POSITION_RANK',
            mode: 'single',
            popup: 'array',
            config: {
              title: '职级',
              type: 'Rank',
              init: reshuffleStatus === 'Edit',
              fieldNames: { value: 'id', name: 'name', code: 'code' }
            }
          }
        },
        {
          type: 'Select',
          hide: [
            'ORG',
            'POST',
            'HRM_POSITION',
            'POSITION_RANK',
            'BANK_ADDRESS',
            'SALARY_BANK_NUMBER',
            'PAY_STRUCTURE'
          ].includes(filedValue),
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'changed_value'],
            required: true
          },
          elementProps: {
            popup: 'array',
            dataList: filed
              .find((x: any) => x.type === filedValue)
              ?.details?.map((y: any) => ({
                ...y,
                id: y.value,
                text: y.name
              }))
          }
        },
        {
          type: 'InputNumber',
          hide: filedValue !== 'BANK_ADDRESS',
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'BANK_ADDRESS'],
            required: true
          },
          elementProps: {
            type: 'changed_value.BANK_ADDRESS',
            maxLength: 19,
            precision: 0
          }
        },
        {
          type: 'Input',
          hide: filedValue !== 'SALARY_BANK_NUMBER',
          formItemProps: {
            label: '变更为',
            name: ['changed_value', 'SALARY_BANK_NUMBER'],
            required: true
          },
          elementProps: {
            type: 'changed_value.SALARY_BANK_NUMBER',
            maxLength: 100
          }
        }
      ]
    }
  ]
}
